async function addToCartClub(productData, customerForm) {
	const response = await fetch(`${window.themeVariables.routes.cartAddUrl}.js`, {
		body: JSON.stringify(productData),
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
	});
	const data = await response.json();

	if (!response.ok) {
		const data = {
			status: response.ok ? 'success' : 'error',
			error: data['description'] || 'Cart update error',
		}
		updatedDispatchEvent(data, 'cart-notification:show');
		return;
	}
	if (
		window.themeVariables.settings.cartType === 'page' ||
		window.themeVariables.settings.pageType === 'cart'
	) {
		return (window.location.href = `${Shopify.routes.root}cart`);
	}

	const detailData = {
		variant: data.items ? data['items'][0] : data,
	}
	updatedDispatchEvent(data,'variant:added');
	await updateAndOpenDrawer(customerForm, data);
}

async function updateAndOpenDrawer(customerForm, data) {
	const response = await fetch(`${window.themeVariables.routes.cartUrl}.js`);

	const cartContent = await response.json();

	const cartData = {
		cart: cartContent,
	};

	updatedDispatchEvent(cartData,'cart:updated');

	cartContent['sections'] = data['sections'];

	const cartRefreshData = {
		cart: cartContent,
		openMiniCart:
			window.themeVariables.settings.cartType === 'drawer' &&
			customerForm.closest('.drawer') === null,
	}

	updatedDispatchEvent(cartRefreshData,'cart:refresh');
}

function updatedDispatchEvent(data,eventType) {
	document.documentElement.dispatchEvent(
		new CustomEvent(eventType, {
			bubbles: true,
			cancelable: eventType==='cart-notification:show'?true:false,
			detail: data,
		})
	);
}

document.addEventListener('DOMContentLoaded', () => {
	document.getElementById('AddToCart').addEventListener('click', async (e) => {
		const customerForm = document.getElementById('customer-form');
		if (!customerForm.checkValidity()) {
			return;
		}
		e.preventDefault();

		const productId = e.target.closest('#AddToCart').dataset.productId;

		const productData = {
			items: [
				{
					id: productId,
					quantity: 1,
					properties: {
						_customer: {
							id: document.getElementById('customer-id').value,
							firstName: document.getElementById('cutomer-first-name').value,
							lastName: document.getElementById('customer-last-name').value,
							phone: document.getElementById('phone').value,
							email: document.getElementById('email').value,
							bday: document.getElementById('bday').value,
						},
					},
				},
			],
			sections: 'mini-cart',
		};

		await addToCartClub(productData, customerForm);

		e.target.closest('#AddToCart').removeAttribute('aria-busy');
	});
});
